<!-- Modal Header with proper icon alignment -->
<div class="modal-header">
  <h3 class="modal-title">{{title}}</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;"
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Modal Body -->
<div class="modal-body" [hidden]="minimise">
  <form name="sbmnForm" novalidate>
    <div class="panel panel-default">
      <div class="panel-body">
        <div class="form-group">
          @for (item of submissionData; track $index) {
<div style="margin-top: 5px;">
            <div class="row" [hidden]="item.hide">
              <div class="col-sm-2">
                <label>
                  {{item.key}}
                </label>
              </div>
              <div class="col-sm-2">
                <textarea class="efile-form-control"
                          [(ngModel)]="item.value"
                          [name]="item.name"
                          [disabled]="item.disabled"
                          cols="20"
                          rows="1"></textarea>
              </div>
            </div>
          </div>
}
        </div>
      </div>
    </div>
  </form>
</div>

<!-- Footer for modal with standardized buttons -->
<div class="modal-footer" [hidden]="minimise">
  <button class="save-button"
          type="button"
          [disabled]="saving"
          (click)="save()">
    @if (saving) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
  </button>
  <button class="delete-button"
          type="button"
          [disabled]="mode === 'create' || !getSubmissionId() || deleting"
          (click)="delete()">
    @if (deleting) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Delete
  </button>
  <button class="cancel-button"
          type="button"
          (click)="cancel()">Cancel</button>
</div>